import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import 'hammerjs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr'; // For auth after login toast
import { CoreModule } from '@core/core.module';
import { CoreCommonModule } from '@core/common.module';
import { CoreSidebarModule, CoreThemeCustomizerModule } from '@core/components';
import { coreConfig } from 'app/app-config';
import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
// import { AuthGuard, ErrorInterceptor, JwtInterceptor } from './auth/helpers';
import localeTr from '@angular/common/locales/tr';
import { registerLocaleData } from '@angular/common';
import { AuthGuard } from './auth/helpers/auth.guards';
import { JwtInterceptor } from './auth/helpers/jwt.interceptor';
import { ErrorInterceptor } from './auth/helpers/error.interceptor';
import { Subject } from 'rxjs';
import { Lib } from './lib/lib';
import { QRCodeModule } from 'angularx-qrcode';

registerLocaleData(localeTr);

const appRoutes: Routes = [
  { path: '', loadChildren: () => import('app/@biz/home/home.module').then(m => m.HomeModule) },
  { path: 'account', loadChildren: () => import('app/@biz/account/account.module').then(m => m.AccountModule), canActivate: [AuthGuard] },
  { path: 'profile', loadChildren: () => import('app/@biz/profile/profile.module').then(m => m.ProfileModule), canActivate: [AuthGuard] },
  { path: 'foil', loadChildren: () => import('app/@biz/foil/foil.module').then(m => m.FoilModule), canActivate: [AuthGuard] },
  { path: 'act', loadChildren: () => import('app/@biz/act/act.module').then(m => m.ActModule), canActivate: [AuthGuard] },

  { path: 'send', loadChildren: () => import('app/@biz/send/send.module').then(m => m.SendModule), canActivate: [AuthGuard] },

  { path: 'order', loadChildren: () => import('app/@biz/order/order.module').then(m => m.OrderModule), canActivate: [AuthGuard] },
  { path: 'plan', loadChildren: () => import('app/@biz/plan/plan.module').then(m => m.PlanModule), canActivate: [AuthGuard] },
  { path: 'prod', loadChildren: () => import('app/@biz/prod/prod.module').then(m => m.ProdModule), canActivate: [AuthGuard] },

  { path: 'user', loadChildren: () => import('app/@biz/_core/user/user.module').then(m => m.UserModule), canActivate: [AuthGuard] },
  { path: 'auth', loadChildren: () => import('app/auth/auth.module').then(m => m.AuthModule) },
  { path: 'misc', loadChildren: () => import('app/misc/miscellaneous.module').then(m => m.MiscellaneousModule) },
  { path: '**', redirectTo: '/misc/error' }
];

@NgModule({
  declarations: [AppComponent],
  exports: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    // RouterModule.forRoot(appRoutes, { scrollPositionRestoration: 'enabled', relativeLinkResolution: 'legacy', onSameUrlNavigation: 'reload' }),
    RouterModule.forRoot(appRoutes, { scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload' }),

    //NgBootstrap
    NgbModule,
    ToastrModule.forRoot(),
    QRCodeModule,

    // Core modules
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,

    // App modules
    LayoutModule,
  ],

  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'tr' },
  ],

  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})


export class AppModule {
  static theUserSubject: Subject<any> = new Subject();

  constructor(public lib: Lib) { }
}